import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createInterestComputationApi(params: any) {
  let apiData: any = {
    startDate: params.startDate,
    endDate: params.endDate,
    programExternalId: params.programmeId.length ? params.programmeId : null,
    counterpartyExternalId: params.customerId.length ? params.customerId : null,
    invoiceNumber: params.invoiceNumber.length ? params.invoiceNumber : null,
    saveReport: params.saveReport
  };
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/interest-computation`;
  return api.create(`${backendApiUrl}`, apiData);
}
export { createInterestComputationApi };
